var _excluded = ["isOpen", "paddingTopSpace", "paddingRightSpace", "paddingBottomSpace", "paddingLeftSpace", "children", "id"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import loadable from "@loadable/component";
import styled, { css } from "styled-components";
import { animationDuration } from "../../../settings";
import space from "../../../utils/space";
var AnimateHeight = loadable(function () {
  return import("react-animate-height");
});
var StyledAnimateHeight = styled(AnimateHeight).withConfig({
  componentId: "sc-fngjaa-0"
})(function (_ref) {
  var $paddingTopSpace = _ref.$paddingTopSpace,
    $paddingRightSpace = _ref.$paddingRightSpace,
    $paddingBottomSpace = _ref.$paddingBottomSpace,
    $paddingLeftSpace = _ref.$paddingLeftSpace;
  return css(["", " ", " ", " ", ""], $paddingTopSpace && css(["padding-top:", ";"], space($paddingTopSpace)), $paddingRightSpace && css(["padding-right:", ";"], space($paddingRightSpace)), $paddingBottomSpace && css(["padding-bottom:", ";"], space($paddingBottomSpace)), $paddingLeftSpace && css(["padding-left:", ";"], space($paddingLeftSpace)));
});
function AnimateHeightOrg(_ref2) {
  var isOpen = _ref2.isOpen,
    paddingTopSpace = _ref2.paddingTopSpace,
    paddingRightSpace = _ref2.paddingRightSpace,
    paddingBottomSpace = _ref2.paddingBottomSpace,
    paddingLeftSpace = _ref2.paddingLeftSpace,
    children = _ref2.children,
    id = _ref2.id,
    restProps = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(StyledAnimateHeight, _extends({
    height: isOpen ? "auto" : 0,
    duration: animationDuration["default"],
    easing: "linear",
    $paddingTopSpace: paddingTopSpace,
    $paddingRightSpace: paddingRightSpace,
    $paddingBottomSpace: paddingBottomSpace,
    $paddingLeftSpace: paddingLeftSpace
  }, restProps, {
    id: id
  }), children);
}
export default AnimateHeightOrg;